module.exports = __webpack_public_path__ + "static/drobin-281797a80e5afd97eb6350181e2936d4.png";